import { Container as PaginationContainer } from "../../../hooks/useOnScrollPagination";
import { CardLoading } from "../../modules/LoadingPlaceholders/CardLoading";
import { NoDataList } from "../../modules/NoDataPlaceholders/NoDataList";
import { Card } from "../../modules/Card";
import { useList } from "./List.hooks";
import { Container, ListContainer } from "./List.styles";

export const List = () => {
  const {
    data,
    isLoading,
    onLastElementVisible,
    generatePseudorandomString,
  } = useList();

  return (
    <Container>
      {(isLoading && data.length === 0) &&
        <ListContainer>
          <CardLoading />
          <CardLoading />
          <CardLoading />
        </ListContainer>
      }
      {(!isLoading && data.length === 0) &&
        <ListContainer>
          <NoDataList />
        </ListContainer>
      }
      {data.length > 0 &&
        <PaginationContainer onLastElementVisible={onLastElementVisible}>
          <ListContainer>
            {data.map((each: any) => (
              <Card key={generatePseudorandomString(16)} data={each} />
            ))}
            {isLoading &&
              <>
                <CardLoading />
                <CardLoading />
                <CardLoading />
              </>
            }
          </ListContainer>
        </PaginationContainer>
      }
    </Container>
  )
}
